import Vue from "vue";
import Buefy from "buefy";
import "buefy/dist/buefy.css";

Vue.use(Buefy);



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/buefy.js